"use client"
import React, { useEffect, useState } from "react";
import { HiOutlineXMark } from "react-icons/hi2";

export function BlogEditModal({ isOpen, onClose, data, onSubmit }) {
  const [formData, setFormData] = useState({
    name: "",
    title: "",
    message: "",
  });
  useEffect(() => {
    if (data) {
      setFormData({
        name: data.name || "",
        title: data.title || "",
        message: data.message || "",
      });
    }
  }, [data]);
  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData((prevData) => ({ ...prevData, [name]: value }));
  };
  
  const handleSubmit = (e) => {
    e.preventDefault();
    onSubmit(formData);
    // console.log("Form data: -->>>", formData);
    onClose()
  };

  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/10 backdrop-blur-sm p-4">

    <div className="relative bg-gray-900 rounded-xl shadow-2xl max-w-lg w-full p-8">

  {/* Close Button */}
  <button
    onClick={onClose}
    className="absolute top-3 right-3 text-gray-300 text-3xl font-bold hover:text-red-500 transition-colors"
  >
     <HiOutlineXMark size={30} />
  </button>

  {/* Modal Title */}
  <h2 className="text-2xl font-semibold mb-6 text-center text-white">
    Edit Blog
  </h2>

  {/* Form */}
  <form onSubmit={handleSubmit} className="space-y-5">

    {/* Name */}
    <div>
      <label className="block text-sm font-medium text-gray-300 mb-1">
        Name
      </label>
      <input
        type="text"
        name="name"
        value={formData.name}
        onChange={handleInputChange}
        className="w-full p-3 rounded-lg bg-gray-800 border border-gray-700 focus:outline-none focus:ring-2 focus:ring-indigo-500 text-white placeholder-gray-400"
        placeholder="Enter your full name"
        required
      />
    </div>

    {/* Blog Title */}
    <div>
      <label className="block text-sm font-medium text-gray-300 mb-1">
        Blog Title
      </label>
      <input
        type="text"
        name="title"
        value={formData.title}
        onChange={handleInputChange}
        className="w-full p-3 rounded-lg bg-gray-800 border border-gray-700 focus:outline-none focus:ring-2 focus:ring-indigo-500 text-white placeholder-gray-400"
        placeholder="Enter blog title"
        required
      />
    </div>

    {/* Description */}
    <div>
      <label className="block text-sm font-medium text-gray-300 mb-1">
        Description
      </label>
      <textarea
        name="message"
        rows={5}
        value={formData.message}
        onChange={handleInputChange}
        className="w-full p-3 rounded-lg bg-gray-800 border border-gray-700 focus:outline-none focus:ring-2 focus:ring-indigo-500 text-white placeholder-gray-400 resize-none"
        placeholder="Write your blog content here..."
        required
      />
    </div>

    {/* Submit Button */}
    <button
      type="submit"
      className="w-full py-3 bg-indigo-600 hover:bg-indigo-700 rounded-lg font-semibold text-white transition-colors shadow-md"
    >
      Update Blog
    </button>

  </form>
</div>
    </div>
  );
}
